import { HTMLAttributes, useEffect, useState } from 'react';
import { FaMagnifyingGlass } from 'react-icons/fa6';

import { Button } from '@hubmaster/ui';
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '@hubmaster/ui/dialog';
import { Input } from '@hubmaster/ui/input';

interface PopupInputCodeProps {
	onInput: (value: string) => void;
	isOpen?: boolean;
	setActive: (value: any) => void;
	title?: string;
	description?: string;
	input?: {
		placeholder?: string;
		type?: HTMLAttributes<HTMLInputElement>['inputMode'];
	};
}
export function PopupInputCode({
	onInput,
	isOpen = false,
	setActive,
	...props
}: PopupInputCodeProps) {
	const [search, setSearch] = useState('');
	const [open, setOpen] = useState(isOpen);

	useEffect(() => {
		setOpen(isOpen);
	}, [isOpen]);

	return (
		<Dialog
			onOpenChange={(state) => {
				setSearch('');
				setOpen(state);
				if (state === false) setActive(false);
			}}
			open={open}
		>
			<DialogContent className="max-w-[375px] rounded-2xl">
				<DialogHeader>
					<DialogTitle>{props.title ?? 'Pesquisar'}</DialogTitle>
					<DialogDescription>
						{props.description ??
							'Faça a busca pelo código do produto ou código de barras.'}
					</DialogDescription>
				</DialogHeader>
				<div className="grid gap-4 py-4">
					<div className="flex items-center justify-center gap-4">
						<Input
							value={search}
							placeholder={props.input?.placeholder ?? '784532242'}
							type="text"
							inputMode={props.input?.type ?? 'numeric'}
							onChange={(e) => setSearch(e.target.value)}
							className="col-span-3"
							onKeyUp={(e) => {
								if (e.key === 'Enter') {
									onInput(search);
									setSearch('');
									setOpen(false);
								}
							}}
						/>
						<Button
							type="submit"
							className="aspect-square px-3 py-3"
							disabled={!search}
							onClick={() => {
								if (search) {
									setSearch('');
									onInput(search);
									setOpen(false);
								}
							}}
						>
							<FaMagnifyingGlass size={20} />
						</Button>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
}
